import React, { useState } from "react";
import AppWrapper from "Components/Routes/AppWrapper";
import PagesWrapper from "Components/Common/Pages/PagesWrapper";
import ConfigurationAPI from "api/configuration/configuration";
import AdminSideBar from "Components/Common/AdminSideBar";
import Button from "Components/Common/Button";
import { toast } from "react-toastify";

function CreateCard({ contentOnly = false, setPopupId, fetchCards }) {
  const [cardName, setCardName] = useState("");
  const [image, setImage] = useState(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setImage(file);
  };

  const handleCreateCard = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("card[img]", image);
    formData.append("card[name]", cardName);
    ConfigurationAPI.createCard(formData)
      .then((response) => {
        const message = response?.data?.message;
        const error = response?.data?.error;
        if (message && error) {
          toast.warning(message + " " + error);
        } else {
          toast.success(response.data.message);
        }
        setPopupId("");
        fetchCards();
        setCardName("");
        setImage("");
      })
      .catch((error) => {
        if (error) {
          toast.error("Something Went Wrong!");
        }
      });
  };

  return (
    <AppWrapper sideBar={<AdminSideBar />} contentOnly={contentOnly}>
      <PagesWrapper>
        <div className="text-24 w-full text-center py-4">Create Card</div>
        <form onSubmit={handleCreateCard}>
          <div className="w-full mt-4">
            <div className="w-[90%] mx-4">
              <label htmlFor="cardName">Card Name</label>
              <input
                type="text"
                className="form-control mt-2"
                placeholder="Enter Card Name"
                value={cardName}
                required
                onChange={(e) => setCardName(e.target.value)}
              />
            </div>
            <div className="w-[90%] mx-4 my-6">
              <label htmlFor="uploadImage">Upload Image</label>
              <input
                type="file"
                className="w-full p-4 mt-2 bg-gray-200 form-control"
                accept="image/*"
                required
                onChange={handleImageUpload}
              />
            </div>
          </div>
          <div className="w-full flex justify-center mb-8">
            <Button type="submit">Create Card</Button>
          </div>
        </form>
      </PagesWrapper>
    </AppWrapper>
  );
}

export default CreateCard;
